import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import DialogSpecNotAvailable from './DialogSpecNotAvailable.vue'

const mountElement = document.querySelector('#vue-dialog-spec-not-available-mount')

if (mountElement) {
  new Vue({
    vuetify,
    el: mountElement,
    components: {
      DialogSpecNotAvailable,
    },
  })
}
